<template>
  <div ref="regalosRef" class="mesa-regalos-section">
    <!-- Decorative Top Seal -->
    <img src="@/assets/sello.avif" alt="Decorative Seal" class="sello-superior" />

    <!-- Title -->
    <h2 class="mesa-titulo animate-item">
      Gift <span class="script">Registry</span>
    </h2>

    <!-- Description -->
    <p class="mesa-descripcion animate-item">
      Your presence is the greatest gift we could ask for.
      However, if you would like to honor us with a gift, we are happy to share the following options:
    </p>

    <!-- Gift Options -->
    <div class="opciones-regalo-container">

      <!-- Option 1: Card Box -->
      <div class="tarjeta-regalo animate-item">
        <img src="@/assets/SOBRE.avif" class="sobre-icono" alt="Envelope" />
        <h3 class="titulo-opcion">Card Box</h3>
        <p class="descripcion-opcion">
          A decorated card box will be available at the reception for your convenience if you wish to leave a gift or card.
        </p>
      </div>

      <!-- Divider -->
      <div class="separador-regalo animate-item" aria-hidden="true">
        <span class="rombo-separador">✦</span>
      </div>

      <!-- Option 2: Zelle -->
      <div class="tarjeta-regalo animate-item">

        <h3 class="titulo-opcion">Zelle</h3>
        <p class="descripcion-opcion">
          If you prefer to send your gift digitally, you may do so by scanning the QR code or using the email address below.
        </p>

        <div class="bloque-datos-zelle">
          <span class="zelle-label">Linked Email:</span>

          <!-- Zelle QR Code -->
          <div class="zelle-qr-container">
            <img src="@/assets/qr.png" class="zelle-qr-img" alt="Zelle QR Code" />
          </div><br><br>

          <span class="zelle-correo">Erik.antunez@gmail.com</span>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'MesaRegalos',
  setup() {
    const regalosRef = ref(null)

    onMounted(() => {
      nextTick(() => {
        const elementosAnimados = regalosRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              gsap.fromTo(
                entry.target,
                { opacity: 0, y: 30, scale: 0.98 },
                {
                  opacity: 1,
                  y: 0,
                  scale: 1,
                  duration: 0.8,
                  ease: 'power2.out',
                }
              )
              observer.unobserve(entry.target)
            }
          })
        }, { threshold: 0.15 })

        elementosAnimados.forEach((el) => observer.observe(el))
      })
    })

    return {
      regalosRef
    }
  }
}
</script>

<style scoped>
.mesa-regalos-section {
  background-color: #78866b;
  color: #f1e9dc;
  font-family: 'Playfair Display', serif;
  width: 90%;
  margin: 0 auto;
  border-radius: 80px 0 0 80px;
  padding: 100px 30px 60px;
  position: relative;
  text-align: center;
}

.sello-superior {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 90px;
  height: auto;
  z-index: 2;
}

.mesa-titulo {
  font-size: 2.4rem;
  font-weight: bold;
  margin-bottom: 35px;
  color: white;
  margin-right: -10px;
  font-family: 'subtitulos';
}

.script {
  font-family: 'corinthia';
  font-size: 2.4rem;
  color: #e7d8cb;
  font-weight: normal;
  margin-left: 8px;
}

.mesa-descripcion {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 1.8;
  letter-spacing: 1px;
  color: #e2d8cb;
  max-width: 310px;
  margin: 0 auto 45px;
  text-transform: none;
}

/* Distribución de las opciones de regalo */
.opciones-regalo-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}

.tarjeta-regalo {
  width: 100%;
  max-width: 300px;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sobre-icono {
  width: 75px;
  height: auto;
  margin-bottom: 15px;
}

/* Logotipo minimalista Zelle */
.zelle-logo-wrapper {
  margin-bottom: 15px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.zelle-texto {
  font-family: 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: -1px;
  font-style: italic;
  opacity: 0.95;
}

.titulo-opcion {
  font-family: 'corinthia', cursive;
  font-size: 2.5rem !important;
  color: #e7d8cb;
  font-weight: normal;
  margin: 0 0 10px 0;
}

.descripcion-opcion {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  line-height: 1.7;
  letter-spacing: 0.5px;
  color: #e2d8cb;
  margin: 0 auto 15px;
}

/* Bloque de datos específicos de Zelle */
.bloque-datos-zelle {
  padding: 18px 20px;
  border-radius: 15px;
  width: 100%;
  box-sizing: border-box;
}

.zelle-label {
  display: block;
  font-family: 'Poppins', sans-serif;
  font-size: 0px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #efe4ca;
  margin-bottom: 4px;
}

.zelle-correo {
  display: block;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 0.5px;
  word-break: break-all;
  margin-bottom: 15px;
}

/* Contenedor e Imagen del QR */
.zelle-qr-container {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 5px auto 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 140px;
  height: 140px;
  box-sizing: border-box;
}

.zelle-qr-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Separador elegante */
.separador-regalo {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 20px;
  margin: 20px auto;
}

.separador-regalo::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(231, 216, 203, 0.4) 50%, transparent);
}

.rombo-separador {
  font-size: 11px;
  color: #e7d8cb;
  background-color: #78866b;
  padding: 0 10px;
  z-index: 1;
}

/* Estado inicial de las animaciones */
.animate-item {
  opacity: 0;
  transform: translateY(30px);
  will-change: transform, opacity;
}
</style>